import Contact from '../../../models/Contact';
import {
  CreateInvestmentEntityRequest,
  InvestmentAllocation,
  InvestmentEntity,
} from '../../../models/InvestmentEntity';
import Investor from '../../../models/Investor';

export type WizardStep = 'lookup' | 'selection' | 'create' | 'allocation' | 'contacts' | 'complete';

export const WIZARD_STEPS: WizardStep[] = [
  'lookup',
  'selection',
  'create',
  'allocation',
  'contacts',
  'complete',
];

export const STEP_LABELS: Record<WizardStep, string> = {
  lookup: 'Lookup Entities',
  selection: 'Choose Entity',
  create: 'Create Entity',
  allocation: 'Allocate Amount',
  contacts: 'Associate Contacts',
  complete: 'Complete',
};

export interface AdminEntityAssociationWizardState {
  currentStep: WizardStep;
  loading: boolean;
  error: string | null;
  entities: InvestmentEntity[];
  selectedEntity: InvestmentEntity | null;
  newEntity: CreateInvestmentEntityRequest | null;
  investor: Investor | null;
  contact: Contact | null;
  allocatedAmount?: number;
  validationErrors?: { [key: string]: string };
  message?: { type: 'success' | 'error'; text: string };
  currentAllocations?: InvestmentAllocation[];
}

export interface AdminEntityAssociationWizardParams {
  investorId?: string;
  selectedEntityId?: string;
  currentState?: string;
}
